export default {"src":"/_next/static/media/loading_ruler.cc00c993.gif","height":910,"width":1000};